import React, { useContext } from 'react';
import Navbar from '../../components/navbar/Navbar';
import { DarkModeContext } from '../../context/darkModeContext';
import './Page404.scss'

const Page404 = () => {
    const { darkMode } = useContext(DarkModeContext);
    return (
        <div className={`theme-${darkMode ? "dark" : "light"}`}>
            <Navbar />
            <div className='page404'>
                <h1>4<span>0</span>4</h1>
                <h2>Page not found</h2>
            </div>
        </div>
    );
};

export default Page404;